<div class="modal-header bg-dark text-center">
    <h4 class="modal-title">Creazione Nuovo <strong>Cliente</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<div class="modal-body" style="margin-bottom: 10px;">
    <p class="section-title">Dati Società / Ditta Individuale</p>

    <div class="form-group">
        <label for="company-name" class="col-sm-3 control-label form-label-aligned m-b-20">Ragione Sociale</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="company-name"
                   name="company-name"
                   class="form-control"
                   placeholder="Inserisci ragione sociale"
                   autocomplete="off"
                   [(ngModel)]="customer.CompanyName">
            <i class="icon-drawer"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="legal-form" class="col-sm-3 control-label form-label-aligned m-b-20">Forma Giuridica</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="legal-form"
                   name="legal-form"
                   class="form-control"
                   placeholder="Inserisci forma giuridica"
                   autocomplete="off"
                   [(ngModel)]="customer.LegalForm">
            <i class="icon-drawer"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="vat" class="col-sm-3 control-label form-label-aligned m-b-20">Partita IVA</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="vat"
                   name="vat"
                   class="form-control"
                   placeholder="Inserisci partita IVA"
                   autocomplete="off"
                   [(ngModel)]="customer.VATNumber">
            <i class="icon-list"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="fiscal-code" class="col-sm-3 control-label form-label-aligned m-b-20">Codice Fiscale</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="fiscal-code"
                   name="fiscal-code"
                   class="form-control"
                   placeholder="Inserisci codice fiscale"
                   autocomplete="off"
                   [(ngModel)]="customer.FiscalCode">
            <i class="icon-list"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="chamber-of-commerce" class="col-sm-3 control-label form-label-aligned m-b-20">Camera di Commercio</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="chamber-of-commerce"
                   name="chamber-of-commerce"
                   class="form-control"
                   placeholder="Inserisci camera di commercio"
                   autocomplete="off"
                   [(ngModel)]="customer.ChamberOfCommerce">
            <i class="icon-drawer"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="rea-number" class="col-sm-3 control-label form-label-aligned m-b-20">Numero REA</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="rea-number"
                   name="rea-number"
                   class="form-control"
                   placeholder="Inserisci numero REA (es. RM - 123456)"
                   autocomplete="off"
                   [(ngModel)]="customer.REANumber">
            <i class="icon-list"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="ateco-code" class="col-sm-3 control-label form-label-aligned m-b-20">Codice ATECO</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="ateco-code"
                   name="ateco-code"
                   class="form-control"
                   placeholder="Inserisci codice ATECO"
                   autocomplete="off"
                   [(ngModel)]="customer.AtecoCode">
            <i class="icon-list"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="registration-date" class="col-sm-3 control-label form-label-aligned m-b-20">Data Iscrizione</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="date"
                   id="registration-date"
                   name="registration-date"
                   class="form-control"
                   autocomplete="off"
                   [(ngModel)]="registrationDateString">
            <i class="icon-calendar"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="visura-date" class="col-sm-3 control-label form-label-aligned m-b-20">Data Visura</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="date"
                   id="visura-date"
                   name="visura-date"
                   class="form-control"
                   autocomplete="off"
                   [(ngModel)]="visuraDateString">
            <i class="icon-calendar"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="employees" class="col-sm-3 control-label form-label-aligned m-b-20">Addetti</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="employees"
                   name="employees"
                   class="form-control"
                   placeholder="Inserisci numero addetti"
                   autocomplete="off"
                   [(ngModel)]="customer.Employees">
            <i class="icon-user"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="head-office" class="col-sm-3 control-label form-label-aligned m-b-20">Sede Legale (Comune e Provincia)</label>
        <div class="col-sm-6 prepend-icon m-b-20">
            <input type="text"
                   id="head-office"
                   name="head-office"
                   class="form-control"
                   placeholder="Comune sede legale"
                   autocomplete="off"
                   [(ngModel)]="customer.HeadOffice">
            <i class="icon-home"></i>
        </div>
        <div class="col-sm-3 m-b-20">
            <input type="text"
                   id="head-office-province"
                   name="head-office-province"
                   class="form-control"
                   placeholder="Provincia"
                   maxlength="2"
                   autocomplete="off"
                   [(ngModel)]="customer.HeadOfficeProvince">
        </div>
    </div>

    <div class="form-group">
        <label for="address" class="col-sm-3 control-label form-label-aligned m-b-20">Via e Civico Sede Legale</label>
        <div class="col-sm-6 prepend-icon m-b-20">
            <input type="text"
                   id="address"
                   name="address"
                   class="form-control"
                   placeholder="Via sede legale"
                   autocomplete="off"
                   [(ngModel)]="customer.Address">
            <i class="icon-home"></i>
        </div>
        <div class="col-sm-3 m-b-20">
            <input type="text"
                   id="house-number"
                   name="house-number"
                   class="form-control"
                   placeholder="Civico"
                   autocomplete="off"
                   [(ngModel)]="customer.HouseNumber">
        </div>
    </div>

    <p class="section-title">Banca, Fatturazione, Bilancio e Contatti</p>

    <div class="form-group">
        <label for="iban" class="col-sm-3 control-label form-label-aligned m-b-20">IBAN</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="iban"
                   name="iban"
                   class="form-control"
                   placeholder="Inserisci IBAN (27 caratteri)"
                   maxlength="27"
                   autocomplete="off"
                   (paste)="onPasteIBAN($event)"
                   (ngModelChange)="onChangeIBAN($event)"
                   [ngModel]="customer.IBAN">
            <i class="icon-credit-card"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="support-bank-name" class="col-sm-3 control-label form-label-aligned m-b-20">Nome Banca di Appoggio</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="support-bank-name"
                   name="support-bank-name"
                   class="form-control"
                   placeholder="Inserisci nome banca di appoggio"
                   autocomplete="off"
                   [(ngModel)]="customer.SupportBankName">
            <i class="icon-bank"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="support-bank-bic" class="col-sm-3 control-label form-label-aligned m-b-20">BIC Banca di Appoggio</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="support-bank-bic"
                   name="support-bank-bic"
                   class="form-control"
                   placeholder="Inserisci BIC banca di appoggio"
                   autocomplete="off"
                   [(ngModel)]="customer.SupportBankBIC">
            <i class="icon-bank"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="sdi-code" class="col-sm-3 control-label form-label-aligned m-b-20">Codice SDI</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="sdi-code"
                   name="sdi-code"
                   class="form-control"
                   placeholder="Inserisci codice SDI"
                   autocomplete="off"
                   [(ngModel)]="customer.SDICode">
            <i class="icon-envelope"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="balance-date" class="col-sm-3 control-label form-label-aligned m-b-20">Data Bilancio</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="date"
                   id="balance-date"
                   name="balance-date"
                   class="form-control"
                   autocomplete="off"
                   [(ngModel)]="balanceDateString">
            <i class="icon-calendar"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="ula-last-balance" class="col-sm-3 control-label form-label-aligned m-b-20">ULA Ultimo Bilancio</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="ula-last-balance"
                   name="ula-last-balance"
                   class="form-control"
                   placeholder="Inserisci ULA ultimo bilancio"
                   autocomplete="off"
                   [(ngModel)]="customer.ULALastBalance">
            <i class="icon-list"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="sales-revenues" class="col-sm-3 control-label form-label-aligned m-b-20">Ricavi Vendite e Prestazioni</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="sales-revenues"
                   name="sales-revenues"
                   class="form-control"
                   placeholder="Inserisci ricavi delle vendite e delle prestazioni"
                   autocomplete="off"
                   [(ngModel)]="customer.SalesRevenues">
            <i class="icon-list"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="total-assets" class="col-sm-3 control-label form-label-aligned m-b-20">Totale Attivo</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="total-assets"
                   name="total-assets"
                   class="form-control"
                   placeholder="Inserisci totale attivo"
                   autocomplete="off"
                   [(ngModel)]="customer.TotalAssets">
            <i class="icon-list"></i>
        </div>
    </div>

    <div class="form-group">
        <label class="col-sm-3 control-label form-label-aligned m-b-20">Email</label>
        <div class="col-sm-9 m-b-20">
            <app-customer-emails-editor [(emails)]="emailInputs"></app-customer-emails-editor>
            <div *ngIf="emailError" class="email-error">{{ emailError }}</div>
        </div>
    </div>

    <div class="form-group">
        <label for="pec" class="col-sm-3 control-label form-label-aligned m-b-20">Domicilio Digitale (PEC)</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="email"
                   id="pec"
                   name="pec"
                   class="form-control"
                   placeholder="Inserisci indirizzo PEC"
                   autocomplete="off"
                   [(ngModel)]="customer.PEC">
            <i class="icon-envelope"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="phone" class="col-sm-3 control-label form-label-aligned m-b-20">Telefono Fisso</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="phone"
                   name="phone"
                   class="form-control"
                   placeholder="Inserisci telefono fisso"
                   autocomplete="off"
                   [(ngModel)]="customer.Phone">
            <i class="icon-phone"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="mobile-phone" class="col-sm-3 control-label form-label-aligned m-b-20">Telefono Cellulare</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="mobile-phone"
                   name="mobile-phone"
                   class="form-control"
                   placeholder="Inserisci telefono cellulare"
                   autocomplete="off"
                   [(ngModel)]="customer.MobilePhone">
            <i class="icon-phone"></i>
        </div>
    </div>

    <p class="section-title">Dati Legale Rappresentante</p>

    <div class="form-group">
        <label for="name" class="col-sm-3 control-label form-label-aligned m-b-20">Nome</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="name"
                   name="name"
                   class="form-control"
                   placeholder="Inserisci nome"
                   autocomplete="off"
                   [(ngModel)]="customer.Name">
            <i class="icon-user"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="surname" class="col-sm-3 control-label form-label-aligned m-b-20">Cognome</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="surname"
                   name="surname"
                   class="form-control"
                   placeholder="Inserisci cognome"
                   autocomplete="off"
                   [(ngModel)]="customer.Surname">
            <i class="icon-user"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="birth-place" class="col-sm-3 control-label form-label-aligned m-b-20">Luogo di Nascita (Comune e Provincia)</label>
        <div class="col-sm-6 prepend-icon m-b-20">
            <input type="text"
                   id="birth-place"
                   name="birth-place"
                   class="form-control"
                   placeholder="Luogo di nascita"
                   autocomplete="off"
                   [(ngModel)]="customer.BirthPlace">
            <i class="icon-pin"></i>
        </div>
        <div class="col-sm-3 m-b-20">
            <input type="text"
                   id="birth-place-province"
                   name="birth-place-province"
                   class="form-control"
                   placeholder="Provincia"
                   maxlength="2"
                   autocomplete="off"
                   [(ngModel)]="customer.BirthPlaceProvince">
        </div>
    </div>

    <div class="form-group">
        <label for="birth-date" class="col-sm-3 control-label form-label-aligned m-b-20">Data di Nascita</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="date"
                   id="birth-date"
                   name="birth-date"
                   class="form-control"
                   autocomplete="off"
                   [(ngModel)]="birthDateString">
            <i class="icon-calendar"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="city" class="col-sm-3 control-label form-label-aligned m-b-20">Residenza (Comune e Provincia)</label>
        <div class="col-sm-6 prepend-icon m-b-20">
            <input type="text"
                   id="city"
                   name="city"
                   class="form-control"
                   placeholder="Comune di residenza"
                   autocomplete="off"
                   [(ngModel)]="customer.City">
            <i class="icon-pin"></i>
        </div>
        <div class="col-sm-3 m-b-20">
            <input type="text"
                   id="province"
                   name="province"
                   class="form-control"
                   placeholder="Provincia"
                   maxlength="2"
                   autocomplete="off"
                   [(ngModel)]="customer.Province">
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default btn-blue btn-embossed" (click)="createCustomer()">Crea</button>
    <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.close()">Chiudi</button>
</div>
